<div style="width: 100%; height: 100%; padding: 12px;" data-cy="auth-access-denied">
  <div style="width: 100%; height: 100%; border-radius: var(--border-radius); text-align: center;" data-cy="auth-access-denied-container">
    <span style="font-size: 48px; color: var(--tdo-primary-accent); font-weight: 500;" data-cy="auth-access-denied-title">
      Oops...
    </span>
    <br />
    <span style="font-weight: bold;" data-cy="auth-access-denied-message">You do not have access to the requested location.  Please contact your administration to be added to a related user group.</span>
    <br />
    <br />
    <span data-cy="auth-access-denied-redirect-message">You will be automatically redirected in <span style="font-weight: 500; font-size: 18px;" data-cy="auth-access-denied-countdown">{{timeUntilRedirect}}</span> seconds.</span>
    <br />
    <br />
    <div style="color: var(--tdo-primary); cursor: pointer; text-decoration: underline;" (click)="navigate()" data-cy="auth-access-denied-return-link">Click here to return to landing.</div>
  </div>
</div>
